(() => {
  const boot = () => {
    document.querySelectorAll('[data-fwricoh]:not([data-fwricoh-ready])').forEach(init);
  };

  const init = (root) => {
    root.dataset.fwricohReady = 'true';

    const state = new Map();
    const cards = [...root.querySelectorAll('[data-fwricoh-item]')];
    const currency = root.dataset.currency || 'USD';
    const routesRoot = window.Shopify?.routes?.root || '/';
    const codes = { 12: root.dataset.code12 || 'FWBUILD12', 15: root.dataset.code15 || 'FWBUILD15' };

    const els = {
      models: [...root.querySelectorAll('[data-fwricoh-model]')],
      panels: [...root.querySelectorAll('[data-fwricoh-panel]')],
      summary: root.querySelector('[data-fwricoh-summary]'),
      subtotal: root.querySelector('[data-fwricoh-subtotal]'),
      filterRow: root.querySelector('[data-fwricoh-filter-row]'),
      filterLabel: root.querySelector('[data-fwricoh-filter-label]'),
      filterSaving: root.querySelector('[data-fwricoh-filter-saving]'),
      kitRow: root.querySelector('[data-fwricoh-kit-row]'),
      kitSaving: root.querySelector('[data-fwricoh-kit-saving]'),
      total: root.querySelector('[data-fwricoh-total]'),
      meter: root.querySelector('[data-fwricoh-meter]'),
      meterTitle: root.querySelector('[data-fwricoh-meter-title]'),
      meterValue: root.querySelector('[data-fwricoh-meter-value]'),
      meterTrack: root.querySelector('[data-fwricoh-meter-track]'),
      meterFill: root.querySelector('[data-fwricoh-meter-fill]'),
      meterCount: root.querySelector('[data-fwricoh-meter-count]'),
      meterNext: root.querySelector('[data-fwricoh-meter-next]'),
      add: root.querySelector('[data-fwricoh-add]'),
      status: root.querySelector('[data-fwricoh-status]')
    };

    const money = (cents) => {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
          style: 'currency', currency
        }).format((Number(cents) || 0) / 100);
      } catch (_) {
        return `$${((Number(cents) || 0) / 100).toFixed(2)}`;
      }
    };

    const dataFor = (card) => ({
      id: String(card.dataset.id || ''),
      productId: String(card.dataset.productId || ''),
      title: card.dataset.title || 'Product',
      role: card.dataset.role || 'accessory',
      price: Number(card.dataset.price || 0),
      compare: Number(card.dataset.compare || 0),
      available: card.dataset.available === 'true',
      includes: String(card.dataset.includes || '').split(',').map(x => x.trim()).filter(Boolean),
      quantity: 0
    });

    const selectedItems = () => [...state.values()].filter(item => item.quantity > 0);

    const includedMap = () => {
      const map = new Map();
      selectedItems().filter(item => item.role === 'kit').forEach(kit => {
        kit.includes.forEach(id => {
          if (!map.has(id)) map.set(id, { quantity: 0, kits: [] });
          const inclusion = map.get(id);
          inclusion.quantity += kit.quantity;
          inclusion.kits.push(`${kit.title}${kit.quantity > 1 ? ` ×${kit.quantity}` : ''}`);
        });
      });
      return map;
    };

    const setQuantity = (card, next) => {
      const item = dataFor(card);
      if (!item.id || !item.available) return;

      const quantity = Math.max(0, Math.min(99, Number(next) || 0));
      if (!quantity) {
        state.delete(item.id);
      } else {
        item.quantity = quantity;
        state.set(item.id, item);
      }
      render();
    };

    const metrics = () => {
      const all = selectedItems();
      const filters = all.filter(item => item.role === 'filter');
      const kits = all.filter(item => item.role === 'kit');
      const filterUnits = filters.reduce((sum, item) => sum + item.quantity, 0);
      const percent = filterUnits >= 2 ? 15 : (kits.length && filterUnits === 1 ? 12 : 0);
      const subtotal = all.reduce((sum, item) => sum + item.price * item.quantity, 0);
      const filterSubtotal = filters.reduce((sum, item) => sum + item.price * item.quantity, 0);
      const filterSaving = percent ? Math.round(filterSubtotal * percent / 100) : 0;
      const kitSaving = kits.reduce((sum, item) => sum + Math.max(0, item.compare - item.price) * item.quantity, 0);
      return { all, filterUnits, percent, subtotal, filterSaving, kitSaving, total: Math.max(0, subtotal - filterSaving) };
    };

    const meterCopy = (m) => {
      const count = m.filterUnits ? `${m.filterUnits} filter${m.filterUnits === 1 ? '' : 's'} selected` : 'No filters selected';
      if (m.filterUnits >= 2) return { stage: 'max', title: 'Maximum filter savings unlocked', value: '15% OFF', count, next: `You save ${money(m.filterSaving)} on filters.` };
      if (m.percent === 12) return { stage: 'unlocked', title: 'Filter savings unlocked', value: '12% OFF', count, next: `Save ${money(m.filterSaving)} · Add 1 more for 15%.` };
      return { stage: m.filterUnits ? 'ready' : 'locked', title: 'Choose 2 filters for 15% off', value: '0% UNLOCKED', count, next: m.filterUnits === 1 ? 'Add 1 more filter for 15% off.' : 'Add 2 filters for 15% off. No kit needed.' };
    };

    const render = () => {
      const m = metrics();
      const included = includedMap();

      cards.forEach(card => {
        const id = String(card.dataset.id || '');
        const selected = state.get(id);
        const quantity = selected?.quantity || 0;
        const inclusion = included.get(id);
        const isIncluded = Boolean(inclusion?.quantity);
        const toggle = card.querySelector('[data-fwricoh-toggle]');
        const minus = card.querySelector('[data-fwricoh-minus]');
        const plus = card.querySelector('[data-fwricoh-plus]');
        const output = card.querySelector('[data-fwricoh-qty]');
        const cardState = card.querySelector('[data-fwricoh-state]');
        const note = card.querySelector('[data-fwricoh-included]');

        card.classList.toggle('is-selected', quantity > 0);
        card.classList.toggle('is-included', isIncluded);
        if (toggle) {
          toggle.setAttribute('aria-pressed', quantity > 0 ? 'true' : 'false');
          toggle.disabled = card.dataset.available !== 'true';
        }
        if (minus) minus.disabled = quantity <= 0;
        if (plus) plus.disabled = card.dataset.available !== 'true' || quantity >= 99;
        if (output) output.textContent = String(quantity);
        if (cardState) {
          cardState.textContent = isIncluded
            ? (quantity ? `${quantity} extra added` : 'Included · Add extra')
            : (quantity ? 'Added' : (card.dataset.available === 'true' ? 'Add' : 'Sold out'));
        }
        if (note) {
          note.hidden = !isIncluded;
          note.textContent = isIncluded
            ? `${inclusion.quantity} included in ${inclusion.kits.join(' + ')}. Use + to add extras.`
            : '';
        }
      });

      const meter = meterCopy(m);
      if (els.summary) els.summary.hidden = !m.all.length;
      if (els.subtotal) els.subtotal.textContent = money(m.subtotal);
      if (els.filterRow) els.filterRow.hidden = !m.filterSaving;
      if (els.filterLabel) els.filterLabel.textContent = `${m.percent}% filter savings`;
      if (els.filterSaving) els.filterSaving.textContent = `−${money(m.filterSaving)}`;
      if (els.kitRow) els.kitRow.hidden = !m.kitSaving;
      if (els.kitSaving) els.kitSaving.textContent = `−${money(m.kitSaving)}`;
      if (els.total) els.total.textContent = money(m.total);
      if (els.add) els.add.disabled = !m.all.length;
      if (els.meter) els.meter.dataset.stage = meter.stage;
      if (els.meterTitle) els.meterTitle.textContent = meter.title;
      if (els.meterValue) els.meterValue.textContent = meter.value;
      if (els.meterCount) els.meterCount.textContent = meter.count;
      if (els.meterNext) els.meterNext.textContent = meter.next;
      if (els.meterTrack) els.meterTrack.setAttribute('aria-valuenow', String(Math.min(2, m.filterUnits)));
      if (els.meterFill) els.meterFill.style.width = `${Math.min(2, m.filterUnits) * 50}%`;
    };

    const activateModel = (key) => {
      const selectedButton = els.models.find(button => button.dataset.fwricohModel === key) || els.models[0];
      if (!selectedButton) return;

      const selectedKey = selectedButton.dataset.fwricohModel;
      els.models.forEach(button => {
        const active = button === selectedButton;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      els.panels.forEach(panel => {
        const active = panel.dataset.fwricohPanel === selectedKey;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
    };

    const pagePath = decodeURIComponent(window.location.pathname || '').toLowerCase();
    let pageModel = '';
    if (pagePath.includes('/products/ricoh-gr-iiix-lens-hood')) pageModel = 'gr3x';
    else if (pagePath.includes('/products/ricoh-gr-iii-lens-hood')) pageModel = 'gr3';
    else if (pagePath.includes('/products/ricoh-gr-iv-')) pageModel = 'gr4';

    activateModel(pageModel || root.dataset.initialModel || 'gr4');

    els.models.forEach(button => {
      button.addEventListener('click', () => activateModel(button.dataset.fwricohModel));
    });

    cards.forEach(card => {
      card.querySelector('[data-fwricoh-toggle]')?.addEventListener('click', () => {
        const current = state.get(String(card.dataset.id || ''))?.quantity || 0;
        setQuantity(card, current ? 0 : 1);
      });
      card.querySelector('[data-fwricoh-minus]')?.addEventListener('click', () => {
        const current = state.get(String(card.dataset.id || ''))?.quantity || 0;
        setQuantity(card, current - 1);
      });
      card.querySelector('[data-fwricoh-plus]')?.addEventListener('click', () => {
        const current = state.get(String(card.dataset.id || ''))?.quantity || 0;
        setQuantity(card, current + 1);
      });
    });

    els.add?.addEventListener('click', async () => {
      const m = metrics();
      if (!m.all.length) return;

      els.add.disabled = true;
      els.add.textContent = 'Adding…';
      if (els.status) els.status.textContent = '';

      try {
        const response = await fetch(`${routesRoot}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: m.all.map(item => ({ id: Number(item.id), quantity: item.quantity })) })
        });
        if (!response.ok) {
          const error = await response.json().catch(() => ({}));
          throw new Error(error.description || error.message || 'Some products could not be added.');
        }

        const code = m.percent ? codes[m.percent] : '';
        if (code) {
          window.location.assign(`${routesRoot}discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(`${routesRoot}cart`)}`);
        } else {
          window.location.assign(`${routesRoot}cart`);
        }
      } catch (error) {
        if (els.status) els.status.textContent = error.message || 'Please try again.';
        els.add.disabled = false;
        els.add.textContent = 'Add selected items to cart';
      }
    });

    render();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
